import { UserRepository, SortBy } from 'src/app/repositories/user.repository';
import { User } from 'src/app/models/user';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { OrderBy } from '../repositories/base.repository';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';

export class LoginService {    
    //sortBy: '' | 'Email'

    constructor(private _userRepo: UserRepository, private _functionsService: FunctionsService) {}

    async loginAsync(email: string, password: string): Promise<CoreResponseMessage> {                    
        let responseMsg: CoreResponseMessage;
        let clientIp = await this._functionsService.getClientIpAsync();

        if (clientIp.ip !== '') {                        
            responseMsg = await this._userRepo.loginAsync(email, password, clientIp.ip);            
            
            if (responseMsg.Status === CoreResponseStatus.OK) {
                let user: User = responseMsg.Result;
                user.IsAdmin = user.Role === 'REGULAR' ? false : true; 
                this._userRepo.setLoggedinUser(user);            
            }
            else
                this._userRepo.setDefaultLoggedinUser();
        }
        else
            responseMsg = { Status: CoreResponseStatus.Failed, Message: 'Failed to get client IP address!', TotalDataCount: 0, Result: null };                                     

        return responseMsg;
    }

    async signupAsync(email: string, password: string): Promise<CoreResponseMessage> {
        let responseMsg = await this._userRepo.signupAsync(email, password);
        
        if (responseMsg.Status === CoreResponseStatus.OK) {
            let user: User = responseMsg.Result;
            user.IsAdmin = user.Role === 'REGULAR' ? false : true;
            this._userRepo.setLoggedinUser(user);
        }
        else
            this._userRepo.setDefaultLoggedinUser();

        return responseMsg;
    }
    
    getLoggedinUser(): User {
        return this._userRepo.getLoggedinUser();
    }

    setLoggedinUser(user: User) {
        this._userRepo.setLoggedinUser(user);
    }

    async logoutAsync(): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage = await this._userRepo.getHeadersAsync(this.getLoggedinUser().Email);

        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            responseMsg = await this._userRepo.signout(headers);

            if (responseMsg.Status === CoreResponseStatus.OK)
                this._userRepo.setDefaultLoggedinUser();
        }        
                        
        return responseMsg;
    }
    
    async updateUserAsync(userToUpdate: User): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage = await this._userRepo.getHeadersAsync(this.getLoggedinUser().Email);

        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            responseMsg = await this._userRepo.updateAsync(headers, userToUpdate);                                  
        }

        return responseMsg;
    }

    async updateSelfAsync(email: string, password: string): Promise<CoreResponseMessage> {
        let responseMsg = await this._userRepo.getHeadersAsync(this.getLoggedinUser().Email);

        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            
            let user = this.getLoggedinUser();
            user.Email = email;
            user.Password = password;

            responseMsg = await this._userRepo.updateSelfAsync(headers, user);
        }

        return responseMsg;
    }

    async getAllSync(requestor: User, pageIndex: number, pageSize: number, sortByStr: string, orderByStr: string): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage = await this._userRepo.getHeadersAsync(requestor.Email);

        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            let sortBy: SortBy = SortBy[sortByStr];
            let orderBy: OrderBy = OrderBy[orderByStr];        
            responseMsg = await this._userRepo.getAllAsync(headers, pageIndex, pageSize, sortBy, orderBy);
        }

        return responseMsg;
    }

    async removeUserAsync(requestor: User, ids: number[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage = await this._userRepo.getHeadersAsync(requestor.Email);

        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            responseMsg = await this._userRepo.removeAsync(headers, ids);
        }

        return responseMsg;
    }

    clearUser(): User {
        return this._userRepo.setDefaultLoggedinUser();        
    }

    async addUsersAsync(requestor: User, usersToAdd: User[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage = await this._userRepo.getHeadersAsync(requestor.Email);

        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            responseMsg = await this._userRepo.addAsync(headers, usersToAdd);   
        }

        return responseMsg;
    }

    async sendEmailPasswordAsync(email: string): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        let clientIp = await this._functionsService.getClientIpAsync();

        if (clientIp.ip.length > 0) {
            const headers = new HttpHeaders().set('IpAddress', clientIp.ip)
                                             .set('Email', email)
                                             .set('Content-Type', 'application/json');
            responseMsg = await this._userRepo.forgotPasswordAsync(headers);
        }

        return responseMsg;
    }
}